import React from 'react';
import { observer } from 'mobx-react-lite';

import { JackpotSymbolImages, T } from '../../../../../../constants';
import { JackpotDetailsSection } from '../jackpot-details-section';
import { useStore, useTranslation } from '../../../../../../hooks';
import { JackpotTierWinners } from './jackpot-tier-winners';
import { JackpotTierName } from '../../../../../../enums';

interface JackpotDetailsWinnersProps {

}

export const JackpotDetailsWinners: React.FC<JackpotDetailsWinnersProps> = observer(() => {

  const { jackpotStore } = useStore();
  const { jackpotWinners } = jackpotStore;

  const t = useTranslation();

  return (
    <JackpotDetailsSection title={t(T.WINNERS)}>
      <div className="jackpot-popup-content">
        <JackpotTierWinners
          tierName={JackpotTierName.Club}
          data={jackpotWinners[JackpotTierName.Club]}
          symbol={JackpotSymbolImages[JackpotTierName.Club]}
        />
        <JackpotTierWinners
          tierName={JackpotTierName.Diamond}
          data={jackpotWinners[JackpotTierName.Diamond]}
          symbol={JackpotSymbolImages[JackpotTierName.Diamond]}
        />
        <JackpotTierWinners
          tierName={JackpotTierName.Heart}
          data={jackpotWinners[JackpotTierName.Heart]}
          symbol={JackpotSymbolImages[JackpotTierName.Heart]}
        />
        <JackpotTierWinners
          tierName={JackpotTierName.Spade}
          data={jackpotWinners[JackpotTierName.Spade]}
          symbol={JackpotSymbolImages[JackpotTierName.Spade]}
        />
      </div>
    </JackpotDetailsSection>
  );
});
